var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 945.42 225.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,225.17V0h54.42v180.97h93.67v44.2H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.24,225.17V0h157v44.2h-102.58v46.18h94.55v44.31h-94.55v46.29h102.58v44.2h-157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m418.45,0l50.36,164.92h1.87L521.03,0h60.91l-75.97,225.17h-72.45L357.54,0h60.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m606.24,225.17V0h157v44.2h-102.58v46.18h94.55v44.31h-94.55v46.29h102.58v44.2h-157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m797.32,225.17V0h54.42v180.97h93.67v44.2h-148.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/LEVEL.aba4113fdfe60b59a3eab3434db90f4f.svg";
export { ForwardRef as ReactComponent };